const translation = {
  'message.join_message': `Hey! Listen! {name} has joined!`,
  'message.channel': `Message {channel}`,
  'header.join': `Join`,
  'invite.header': `You've been invited to join a server`
}

export default translation



// WEBPACK FOOTER //
// ./src/app/locales/translations/en.ts